


















import Vue, { VueConstructor } from 'vue';
import { mapState } from 'vuex';
import { SEARCH_URL } from '@/constants';
import { Lemma } from '@/types/lemmalist';
import { ErrorDisplay } from '../util/util';
import ErrorAlert from '@/generic/components/ErrorAlert.vue';

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      lemmalist: InstanceType<typeof HTMLElement>,
    };
  }
>).extend({

  components: {
    ErrorAlert,
  },

  computed: {
    lemmas() { return this.$store.state.lemmalist.lemmas; },
    loading() { return this.$store.state.lemmalist.loading; },
    error(): ErrorDisplay { return this.$store.state.lemmalist.error; },
    currentDocPid() { return this.$store.state.article.pid; },
  },

  watch: {
    lemmas(): void { this.ensureCurrentLemmaVisible(); },
    currentDocPid(): void { this.ensureCurrentLemmaVisible(); },
    $route(): void { this.ensureCurrentLemmaVisible(); },
  },

  methods: {
    ensureCurrentLemmaVisible() {
      requestAnimationFrame(() => {
        if (!this.currentDocPid || !this.lemmas)
          return;
        const ll = this.$refs.lemmalist;
        const rectLemmalist = ll.getBoundingClientRect();
        const curr = ll.querySelector<HTMLElement>('ul.lemmas li.current');
        if (curr) {
          const rectLemma = curr.getBoundingClientRect();
          const lemmaVisible = rectLemma.top >= rectLemmalist.top && rectLemma.bottom <= rectLemmalist.bottom;
          if (!lemmaVisible) {
            curr.scrollIntoView({ block: "center" });
          }
        }
      });
    },
  },

});

